import GallerySync from "@/components/GallerySync";

const AdminSync = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="w-full max-w-xl">
        <GallerySync />
      </div>
    </div>
  );
};

export default AdminSync;
